// 퇴직연금 DC 연도별 부담금 (육아휴직 등 무급 기간이 있는 해 포함 — 고용노동부 해석)
//
//   W: 그 해 지급된 임금총액(무급 휴직 중 임금은 없음)
//   T: 그 해 근로관계가 유지된 월수(휴직 기간 포함)
//   L: 그 해 휴직 등 임금이 발생하지 않은 월수
//   T − L: 실제 임금이 발생한 월수 = 월별 산입분의 합
//
//   부담금 = W × T ÷ (T − L) × 1/12
//     · 12개월 근로, 휴직 없음:        W ÷ 12
//     · 12개월 근로, L개월 휴직:       W ÷ (12 − L)
//     · 입사·퇴사 연도(T < 12):         W × T ÷ (T − L) ÷ 12  — 복직 없이 퇴사한 해도 같은 식
//   T − L = 0(그 해 전체 휴직)이면 직전 연도 부담금을 승계한다(휴직 직전 연도 임금총액의 1/12 이상).
//   근로관계가 12개월이 안 되는 해(휴직 중 복직 없이 퇴사 등)는 근로관계 월수만큼: 직전 연도 부담금 × T/12.

// 그 해 근로관계가 유지된 월수: 재직기간 [start, end] 와 겹치는 달의 수(시작·끝 달은 1개월로 센다)
export function employedMonths(year, start, end) {
  let count = 0;
  for (let m = 1; m <= 12; m += 1) {
    const monthStart = new Date(year, m - 1, 1);
    const monthEnd = new Date(year, m, 0);
    if ((!start || start <= monthEnd) && (!end || end >= monthStart)) count += 1;
  }
  return count;
}

const won = (v) => Math.round(v).toLocaleString('ko-KR');
const mon = (v) => (Math.abs(v - Math.round(v)) < 0.005 ? String(Math.round(v)) : v.toFixed(2));

// months: [{ y, wage, share }] — share 는 그 달 산입분(0~1, 사람이 고친 값 반영)
// 반환: 연도별 [{ year, wageTotal, employed(T), worked(T−L), leave(L), contribution, inheritedFrom, rule }]
export function yearlyContributions(months, start, end) {
  const byYear = {};
  months.forEach(({ y, wage, share }) => {
    if (!byYear[y]) byYear[y] = { wageTotal: 0, worked: 0 };
    byYear[y].wageTotal += wage;
    byYear[y].worked += share;
  });
  const out = [];
  let last = null;
  Object.keys(byYear).map(Number).sort((a, b) => a - b).forEach((year) => {
    const { wageTotal } = byYear[year];
    const employed = employedMonths(year, start, end);
    const worked = Math.min(byYear[year].worked, employed);
    const leave = Math.max(0, employed - worked);
    let contribution;
    let inheritedFrom = null;
    let rule;
    let calc;
    if (worked > 0 && employed > 0) {
      contribution = Math.round((wageTotal * employed) / (12 * worked));
      // 산식에 실제 값을 넣어 보여 준다: W × T ÷ (T − L) ÷ 12 = 부담금
      rule = `${won(wageTotal)} × ${employed} ÷ (${employed} − ${mon(leave)}) ÷ 12 = ${won(contribution)}`;
      calc = { kind: 'formula', top: `${won(wageTotal)} × ${employed}`, bottom: `(${employed} − ${mon(leave)}) × 12`, result: won(contribution) };
      last = { contribution, year };
    } else if (last && employed > 0) {
      contribution = employed >= 12 ? last.contribution : Math.round((last.contribution * employed) / 12);
      inheritedFrom = last.year;
      rule = employed >= 12 ? `임금 발생 0개월 — ${last.year}년 부담금 ${won(last.contribution)} 승계`
        : `임금 발생 0개월 — ${last.year}년 부담금 ${won(last.contribution)} × ${employed} ÷ 12 = ${won(contribution)}`;
      calc = employed >= 12
        ? { kind: 'inherit', note: `${last.year}년 부담금 승계`, result: won(contribution) }
        : { kind: 'formula', note: `${last.year}년 부담금`, top: `${won(last.contribution)} × ${employed}`, bottom: '12', result: won(contribution) };
    } else {
      contribution = 0;
      rule = '임금 발생 0개월';
      calc = { kind: 'none', note: '임금 발생 0개월', result: '0' };
    }
    out.push({ year, wageTotal, employed, worked, leave, months: worked, contribution, inheritedFrom, rule, calc });
  });
  return out;
}
